export default __webpack_public_path__ + "static/media/star icon.4d34f068.png";